import {CreateFinal} from "./Create";
import {ListFinal} from "./List";

export default {
    name:   'feeds',
    create: CreateFinal,
    list: ListFinal,
    options: { label: 'Feeds' }
};
